import ContextualManager from './Manager.component';

export default ContextualManager;
